import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2bf890c9")

_pushScopeId("data-v-2bf890c9")
const _hoisted_1 = { class: "STime__icon" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_clock = _resolveComponent("icon-clock")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock("div", {
    class: ["STime", { invalid: _ctx.isInvalid }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_icon_clock)
    ]),
    _withDirectives(_createVNode("input", {
      class: "default-input",
      type: "text",
      value: _ctx.value,
      placeholder: _ctx.placeholder,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args))),
      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitChange && _ctx.emitChange(...args)))
    }, null, 40, ["value", "placeholder"]), [
      [_directive_maska, { mask: _ctx.timeMask, tokens: _ctx.timeTokens }]
    ])
  ], 2))
})